import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatIsoDate';
import { MODULE_GESTION_COMMERCIALE } from '@/configuration/devisConf';
import getExonerationTva from '@/services/devis/getExonerationTva';


function annonceurWithExonerationTva(ligne, devisCommande) {
  const annonceurExonererTva = devisCommande.intervenants.some((int) => {
    return int.annonceur && getExonerationTva(int);
  });
  if (annonceurExonererTva) ligne.tauxTva = 0;
}

export default function preparationEnvoiBack(devisCommandeFacture) {
  const copieNouveauDevisCommande = cloneDeep(devisCommandeFacture);
  const indexLigneIntervenantAjout = copieNouveauDevisCommande
    .intervenants.findIndex(intervenant => {
      return !intervenant.nomCommercial;
    });
  if (indexLigneIntervenantAjout !== -1) {
    copieNouveauDevisCommande.intervenants.splice(
      indexLigneIntervenantAjout,
      1,
    );
  }
  if (copieNouveauDevisCommande.dateDevisCommande) {
    copieNouveauDevisCommande.dateDevisCommande = moment(
      copieNouveauDevisCommande.dateDevisCommande,
    ).format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande.dateValidite) {
    copieNouveauDevisCommande.dateValidite = moment(copieNouveauDevisCommande.dateValidite)
      .format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande.dateRenouvellement) {
    copieNouveauDevisCommande.dateRenouvellement = moment(
      copieNouveauDevisCommande.dateRenouvellement,
    )
      .format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande.datePremierAffichage) {
    copieNouveauDevisCommande.datePremierAffichage = moment(
      copieNouveauDevisCommande.datePremierAffichage,
    )
      .format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande.echeanciers) {
    copieNouveauDevisCommande.echeanciers.forEach((echeancier) => {
      delete echeancier.openEcheancierLignes;
      echeancier.dateDebut = formatDate(echeancier.dateDebut);
      echeancier.dateFin = formatDate(echeancier.dateFin);
      echeancier.dateFinPremiereEcheance = formatDate(echeancier.dateFinPremiereEcheance);
      echeancier.echeancierLignes.forEach((ligne) => {
        if (ligne.fromGeneration) delete ligne.id;
        ligne.dateDebut = formatDate(ligne.dateDebut);
        ligne.dateFin = formatDate(ligne.dateFin);
        ligne.datePrevisionnelleFacturation = formatDate(ligne.datePrevisionnelleFacturation);
      });
    });
  }
  copieNouveauDevisCommande.lignesCommande.forEach((ligne) => {
    if (!ligne.prixUnitaire) {
      ligne.prixUnitaire = 0;
    }
    annonceurWithExonerationTva(ligne, copieNouveauDevisCommande);
    if (ligne.lignesCommande) {
      ligne.lignesCommande.forEach((ligneEnfant) => {
        delete ligneEnfant.dateDebut;
        delete ligneEnfant.dateFin;
        if (!ligneEnfant.prixUnitaire) ligneEnfant.prixUnitaire = 0;
        annonceurWithExonerationTva(ligneEnfant, copieNouveauDevisCommande);
      });
    }
    if (ligne.dateDebut) {
      ligne.dateDebut = moment(ligne.dateDebut).format('YYYY-MM-DD');
    }
    if (ligne.dateFin) {
      ligne.dateFin = moment(ligne.dateFin).format('YYYY-MM-DD');
    }
    if (ligne.dateLivraison) {
      ligne.dateLivraison = moment(ligne.dateLivraison).format('YYYY-MM-DD');
    }
    if (ligne.liaisonsTarif && ligne.liaisonsTarif.length) {
      ligne.liaisonsTarif.forEach(liaisonsTarif => {
        if (liaisonsTarif.dateDebut) {
          liaisonsTarif.dateDebut = moment(liaisonsTarif.dateDebut).format('YYYY-MM-DD');
        }
        if (liaisonsTarif.dateFin) {
          liaisonsTarif.dateFin = moment(liaisonsTarif.dateFin).format('YYYY-MM-DD');
        }
      });
    }
    if (ligne.produit) {
      if (ligne.produit.produitReseau) {
        if (ligne.produit.produitReseau.dateDebut) {
          ligne.produit.produitReseau.dateDebut = formatDate(ligne.produit.produitReseau.dateDebut);
        }
        if (ligne.produit.produitReseau.dateFin) {
          ligne.produit.produitReseau.dateFin = formatDate(ligne.produit.produitReseau.dateFin);
        }
      }
      if (ligne.produit.liaisonsTarif) {
        ligne.produit.liaisonsTarif.forEach(liaisonsTarif => {
          if (liaisonsTarif.dateDebut) {
            liaisonsTarif.dateDebut = formatDate(liaisonsTarif.dateDebut);
          }
          if (liaisonsTarif.dateFin) {
            liaisonsTarif.dateFin = formatDate(liaisonsTarif.dateFin);
          }
        });
      }
    }
    if (ligne.affectation) {
      ligne.affectation.forEach(aff => {
        if (aff.dureeAffectation.dateDebut) {
          aff.dureeAffectation.dateDebut = formatDate(aff.dureeAffectation.dateDebut);
        }
        if (aff.dureeAffectation.dateFin) {
          aff.dureeAffectation.dateFin = formatDate(aff.dureeAffectation.dateFin);
        }
      });
    }
  });
  copieNouveauDevisCommande.module = MODULE_GESTION_COMMERCIALE;
  return copieNouveauDevisCommande;
}



// WEBPACK FOOTER //
// ./src/services/devis/preparationEnvoiBack.js